import { smsTemplateSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod/v4";

export const getSmsTemplateById = {
  name: "getSmsTemplateById" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ template: smsTemplateSchema }),
};
